import { SUBSCRIPTION_PLANS_PREMIUM_PLUS } from '@gymaholic/packages'

export function isPremiumPlusSubscriptionUserUtil (subscriptionPlan) {
  return SUBSCRIPTION_PLANS_PREMIUM_PLUS.includes(subscriptionPlan)
}
